import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    height: "100vh"
  },
  header: {
    color: "#10459a",
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("lg")]: {
      marginTop: theme.spacing(5),
    },
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(20),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(11),
    },
  },
  reactBody: {
    [theme.breakpoints.down("sm")]: {
      height: `calc(100vh - 177px)`,
    },
  },
  body: {
    marginTop: theme.spacing(10),
    height: 500,
    width: 800,
    [theme.breakpoints.down("sm")]: {
      maxHeight: `600px`,
      height: "auto",
      width: "98%",
      marginTop: theme.spacing(4),
    },
  },
  bodyImg: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    backgroundImage: "url(/images/main/img_doctors.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    paddingBottom: "5%",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-start",
      backgroundImage: "url(/images/main/img_doctors_m.png)",
      minHeight: 398,
      backgroundSize: "auto",
      backgroundPosition: "center bottom",
    },
    [theme.breakpoints.down("xs")]: {
      backgroundSize: "cover",
    },
  },
  regular: {
    fontWeight: 400,
  },

  button: {
    marginTop: 380,
    width: 432,
    height: 78,
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      width: "90%",
      maxWidth: 432,
      marginTop: 0,
    },
    [theme.breakpoints.down("sm")]: {
      width: 160,
      height: 54,
      borderRadius: 28,
      marginTop: 0,
    },
  },
}));

const MainComp = () => {
  const classes = useStyles();
  const history = useHistory();
  const handleLink = (link) => {
    history.push(`/select`);
  };
  return (
    <Grid container direction="row" className={classes.root}>
      <Grid
        container
        justify="center"
        direction="column"
        alignItems="center"
        className={classes.header}
      >
        <Typography variant="h1">암 조기 검진</Typography>
        <Typography variant="h1">
          <span className={classes.regular}>받는것이 좋을까요?</span>
        </Typography>
      </Grid>
      <Grid container justify="center" className={classes.reactBody}>
        <Grid container justify="center" className={classes.body}>
          <Grid
            container
            justify="center"
            alignItems="flex-end"
            className={classes.bodyImg}
          >
            <Button
              onClick={handleLink}
              variant="contained"
              color="primary"
              className={classes.button}
            >
              시작하기
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {/* <Grid className={classes.footer}>
        <Button
          onClick={handleLink}
          variant="contained"
          color="primary"
          className={classes.button}
        >
          시작하기
        </Button>
      </Grid> */}
    </Grid>
  );
};

export default MainComp;
